export default __webpack_public_path__ + "static/media/download-icon.13dc9118.svg";